import { trpc } from '@/shared/api';

/**
 * 후기 상세를 관리자가 직접 다시 불러온다(충돌 뒤 "새로 불러오기"). 불러올 때마다 개인정보 조회 기록이 하나 남는다 —
 * 상세가 자동으로 다시 불리지 않으므로 이 명시적 동작이 최신 수정 시각을 받는 유일한 길이다.
 */
export const useReloadReviewDetail = (): ((reviewId: string) => Promise<unknown>) => {
  const utils = trpc.useUtils();
  return (reviewId) => utils.reviewManagement.get.fetch({ reviewId }, { staleTime: 0 });
};
